import { retrieveErrorFromApi } from '../../../../helper'
import { setAppErrors } from '../../../action/system'
import updatePayer from '../../../axios/order/payer/put'

export const updatePayerThunk = (orderId, data) => dispatch => {
	return updatePayer(orderId, data)
		.then(res => {
		})
		.catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}
